module.exports = __webpack_public_path__ + "img/icon_web_btn.aecfb121.svg";